import React, { useState, useEffect } from "react";
import { Card } from "primereact/card";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";

type DeviceMessagingProps = {
  onPrevious: () => void;
  onNext: () => void;
};
const DeviceMessaging = (props: DeviceMessagingProps) => {
  const { t } = useTranslation();
  const [warningError, setWarningError] = useState<boolean>(false);

  const tableData = [
    {
      id: 1,
      isCheckbox: true,
      name: t("sms_user_0_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 2,
      isCheckbox: true,
      name: t("sms_user_1_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 3,
      isCheckbox: true,
      name: t("sms_user_2_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 4,
      isCheckbox: true,
      name: t("sms_user_3_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 5,
      isCheckbox: true,
      name: t("sms_user_4_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 6,
      isCheckbox: true,
      name: t("sms_user_5_number"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
      checkedValue: "",
    },
    {
      id: 7,
      isCheckbox: false,
      name: t("warning_level"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
    },
    {
      id: 8,
      isCheckbox: false,
      name: t("alarm_level"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
    },
    {
      id: 9,
      isCheckbox: false,
      name: t("sms_silence_time"),
      field: "",
      trigger: "",
      warning: "",
      alarm: "",
      system: "",
      isChecked: true,
    },
  ];
  const [messagingData, setMessagingData] = useState<any>([]);
  const [rowDataState, setRowDataState] = useState<any>({});

  const handleInputChange = (id: any, columnName: string, value: any) => {
    setRowDataState((prevRowDataState: any) => ({
      ...prevRowDataState,
      [id]: {
        ...prevRowDataState[id],
        [columnName]: value,
      },
    }));
  };
  const inputFields = (rowData: any) => {
    return (
      <>
        <div style={{ textAlign: "center" }}>
          <InputText
            value={rowDataState[rowData.id]?.inputValue || ""}
            onChange={(e) =>
              handleInputChange(rowData.id, "inputValue", e.target.value)
            }
          />
        </div>

        {rowData["id"] === 7 && warningError && (
          <div className="col-12 p-0">
            <p className="error-message mb-0" style={{ fontSize: "12px" }}>
              {t("warning_error")}
            </p>
          </div>
        )}
      </>
    );
  };

  const handleCheckboxChange = (
    id: any,
    columnName: string,
    isChecked: boolean
  ) => {
    setRowDataState((prevRowDataState: any) => {
      let updatedState = {
        ...prevRowDataState,
        [id]: {
          ...prevRowDataState[id],
          [columnName]: isChecked,
        },
      };

      // Additional logic for dependent checkboxes
      if (columnName === "trigger" && isChecked) {
        updatedState[id].warning = true;
        updatedState[id].alarm = true;
      } else if (columnName === "warning" && isChecked) {
        updatedState[id].alarm = true;
      }
      let checkedValue = 0;
      if (updatedState[id].trigger) checkedValue += 1;
      if (updatedState[id].warning) checkedValue += 2;
      if (updatedState[id].alarm) checkedValue += 4;
      if (updatedState[id].system) checkedValue += 8;

      updatedState[id].checkedValue = checkedValue;

      return updatedState;
    });
  };
  const checkboxColumn = (columnName: string) => (rowData: any) => {
    if (rowData["isCheckbox"]) {
      return (
        <div style={{ textAlign: "center" }}>
          <Checkbox
            onChange={(e) =>
              handleCheckboxChange(rowData.id, columnName, e.checked)
            }
            checked={rowDataState[rowData.id]?.[columnName] || false}
          />
        </div>
      );
    }
  };

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column className="center-label" header={t("field_name")} rowSpan={3} />
        <Column className="center-label" header={t("input")} rowSpan={3} />

        <Column className="center-label" header={t("message_on")} colSpan={5} />
      </Row>

      <Row>
        <Column
          className="center-label"
          header={t("trigger")}
          field="trigger"
        />
        <Column
          className="center-label"
          header={t("warning")}
          field="warning"
        />
        <Column className="center-label" header={t("alarm")} field="alarm" />
        <Column className="center-label" header={t("system")} field="system" />
      </Row>
    </ColumnGroup>
  );
  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem("lang")!);
    setMessagingData(tableData);
    if (localStorage.getItem("deviceMessaging")) {
      setRowDataState(JSON.parse(localStorage.getItem("deviceMessaging")!));
    }
  }, [i18n.language]);
  return (
    <>
      <Card
        title={t("device_messaging")}
        className="InputForms_container spaceUnset mt-4"
      >
        <DataTable
          value={messagingData}
          showGridlines
          headerColumnGroup={headerGroup}
          responsiveLayout={"scroll"}
        >
          <Column field="name" header={t("field_name")}></Column>
          <Column field="field" header={t("input")} body={inputFields}></Column>
          <Column
            field="trigger"
            header="Trigger"
            body={checkboxColumn("trigger")}
          />
          <Column
            field="warning"
            header="Warning"
            body={checkboxColumn("warning")}
          />
          <Column field="alarm" header="Alarm" body={checkboxColumn("alarm")} />
          <Column
            field="system"
            header="System"
            body={checkboxColumn("system")}
          />
        </DataTable>

        <div className="flex flex-wrap align-items-center justify-content-center lg:justify-content-between mt-4">
          <p className="text-danger text-underline"></p>
          <p className="text-danger"></p>
          <div>
            <Button
              icon="pi pi-angle-left"
              label={t("previous")}
              className="p-button-outlined p-button-secondary"
              onClick={() => props.onPrevious()}
            />
            <Button
              icon="pi pi-angle-right"
              label={t("next")}
              className="p-button-outlined p-button-secondary ml-2"
              iconPos="right"
              onClick={() => {
                if (rowDataState[7] && rowDataState[8]) {
                  const inputValue7 = Number(rowDataState[7]["inputValue"]);
                  const inputValue8 = Number(rowDataState[8]["inputValue"]);
                  if (inputValue7 && inputValue8) {
                    if (inputValue7 > inputValue8) {
                      setWarningError(true);
                    } else {
                      localStorage.setItem(
                        "deviceMessaging",
                        JSON.stringify(rowDataState)
                      );
                      props.onNext();
                    }
                  } else {
                    localStorage.setItem(
                      "deviceMessaging",
                      JSON.stringify(rowDataState)
                    );
                    props.onNext();
                  }
                } else {
                  localStorage.setItem(
                    "deviceMessaging",
                    JSON.stringify(rowDataState)
                  );
                  props.onNext();
                }
              }}
            />
          </div>
        </div>
      </Card>
    </>
  );
};

export default DeviceMessaging;
